export const IMG = {
  cloudAdmin: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/1252eed50af2ba11b5a68e1dc818dd6f5035384e4d6b11c2b9ade53a5cbc00bc.jpeg",
  iaSupport: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/029336b1a77a07bc82f9e6c367abd8b6e529ff3def9b2ee1577c7f6bb274e8ee.jpeg",
  heroTeam: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/a9cdef038eadbddd030761ba784f4e60e2d25a0ffbce92c8e23efad35c255fa7.jpeg",
  heroRack: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/c5e8bc783531b842695a8a265b660192c481df3469da1453804cd4be3c4b5d53.jpeg",
  heroOffice: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/316940713cfa9ce1de344a502f25dcd3a6e1420b26631510045d85dcda6dc776.jpeg",
  heroDesk1: "https://images.unsplash.com/photo-1712159018726-4564d92f3ec2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  heroDesk2: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  heroDesk3: "https://images.unsplash.com/photo-1714079761488-e0c9b9ac4138?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  heroGraphs: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  heroFinal: "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  heroOps: "https://images.unsplash.com/photo-1629904853716-f0bc54eea481?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  rack: "https://images.unsplash.com/photo-1785682117028-6fcf2c0b515b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  rackInstall: "https://images.unsplash.com/photo-1783419538460-676cb89a0d19?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  switch: "https://images.unsplash.com/photo-1680691257251-5fead813b73e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  phone: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/3fd2ea69b9cb3e560ae8f4ea8d81fa2c730fd0da0396d79bceac2f7527c4672b.jpeg",
  phoneRoom: "https://images.unsplash.com/photo-1631248244253-eb4d7cfead9f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  team: "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  office: "https://images.unsplash.com/photo-1603201667141-5a2d4c673378?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  meeting: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  noumea: "https://images.unsplash.com/photo-1694605702455-af774932101c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800",
  mine: "https://images.unsplash.com/photo-1709489662983-3674d790b224?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  helpline: "https://images.unsplash.com/photo-1553775282-20af80779df7?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  gym: "https://images.unsplash.com/photo-1689877020200-403d8542d95d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  callCenter: "https://images.unsplash.com/photo-1626863905121-3b0c0ed7b94c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  hotel: "https://images.unsplash.com/photo-1777016844282-46fa8713cdae?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  ceiling: "https://static.prod-images.emergentagent.com/jobs/3d724c4a-9f39-4ce9-b4f8-aedd7c2dee8d/images/243544134c355465c8dd5b0922ebc16f77405358c21950ecd3d09074cbd1c55b.jpeg",
};

export const CONTACT = {
  phone: "+687 29 70 00",
  phoneHref: "tel:+687297000",
  hotline: "+687 29 70 70",
  hotlineHref: "tel:+687297070",
  email: "contact@enova.nc",
  supportEmail: "support@enova.nc",
  hoursShort: "Du lundi au vendredi, 7h – 17h",
  address: "6 rue Jean Chalier",
  city: "98800 Nouméa, Nouvelle-Calédonie",
  hours: [
    ["Lundi – Vendredi", "7h00 – 17h00"],
    ["Samedi – Dimanche", "Fermé"],
  ],
};

export const THEMES = [
  {
    slug: "infogerance",
    name: "Infogérance",
    color: "#45ADE0",
    icon: "cursor",
    tagline: "Nous exploitons, supervisons et maintenons votre informatique. Et nous vous en rendons compte.",
    short: "Exploitation, supervision, maintenance, sécurité et reporting de votre SI.",
    image: "rack",
    pains: [
      "Personne n'a une vue d'ensemble de l'état de votre parc, de vos serveurs et de vos sauvegardes.",
      "Les incidents sont découverts par les utilisateurs, pas par ceux qui exploitent le système.",
      "Les sauvegardes « tournent », mais personne ne les a jamais testées.",
      "Votre équipe interne est absorbée par l'exploitation courante au détriment des projets.",
    ],
    offers: [
      ["Supervision", "Serveurs, postes et réseau surveillés en continu pour détecter les incidents avant qu'ils n'impactent vos utilisateurs."],
      ["Exploitation & maintenance", "Mises à jour, maintenance préventive et corrective, gestion des changements."],
      ["Sauvegarde & sécurité", "Sauvegardes externalisées et testées, antivirus managé, plan de reprise."],
      ["Gestion du parc & des licences", "Inventaire, cycle de vie des équipements, suivi des licences et des garanties."],
      ["Reporting & comités de suivi", "Un état régulier de votre SI, des indicateurs et des points de suivi pour décider ensemble."],
    ],
    brands: ["Microsoft", "Lenovo", "HP", "Ubiquiti UniFi"],
    faq: [
      ["Que comprend un contrat d'infogérance ?", "Le périmètre est défini avec vous : supervision, exploitation, maintenance, support utilisateurs, sauvegardes, reporting. Vous pouvez nous confier tout ou partie de votre système d'information."],
      ["Pouvez-vous travailler avec notre équipe informatique interne ?", "Oui. Nous pouvons prendre en charge un périmètre précis (exploitation, support, sauvegardes…) en complément de votre équipe, avec des rôles clairement définis."],
      ["Comment se passe la prise en charge d'un incident ?", "Notre service support est ouvert de 7h à 17h. Votre appel est pris en charge immédiatement par un technicien, qui diagnostique le problème et organise l'intervention, à distance ou sur site."],
    ],
  },
  {
    slug: "service-desk",
    name: "Service Desk & Support utilisateurs",
    logo: "enova-wordmark",
    color: "#45ADE0",
    icon: "headset",
    tagline: "Nous prenons en charge tout ou partie du support de vos utilisateurs.",
    short: "Hotline, support N1 / N2 / N3, tickets, escalades, SLA, reporting et KPI.",
    image: "callCenter",
    pains: [
      "Vos utilisateurs ne savent pas qui appeler, et les demandes se perdent entre les appels et les e-mails.",
      "Votre équipe informatique passe ses journées sur des demandes simples au lieu d'avancer sur ses projets.",
      "Vous n'avez aucune visibilité sur les volumes, les délais de traitement ni le backlog.",
      "Vous devez absorber un pic d'activité ou renforcer une équipe sans dégrader le service.",
    ],
    offers: [
      ["Hotline utilisateurs", "Un point d'entrée unique pour vos collaborateurs, par téléphone et par e-mail."],
      ["Support N1 / N2 / N3", "Qualification, résolution et escalade au bon niveau d'expertise, à distance ou sur site."],
      ["Incidents, demandes & tickets", "Chaque demande est enregistrée, priorisée, suivie et clôturée. Le backlog est suivi en continu."],
      ["Escalades & SLA", "Des règles d'escalade claires et des niveaux de service définis avec vous."],
      ["Reporting & KPI", "Volumes, délais, taux de résolution : un reporting régulier pour piloter la qualité du service."],
      ["Centre de services", "Une organisation inspirée des bonnes pratiques ITIL, adaptée à votre contexte."],
    ],
    inHouse: {
      eyebrow: "Modes d'intervention",
      title: "Un dispositif adapté à votre organisation.",
      lead: "Prestation dédiée, mutualisée ou en régie : vous choisissez le format, nous assurons la continuité et la qualité du support.",
      items: [
        ["Équipe dédiée", "Des techniciens ENOVA consacrés à votre support, qui connaissent vos utilisateurs, vos outils et vos process."],
        ["Équipe mutualisée", "Notre centre de services prend en charge vos demandes, avec la souplesse d'une équipe partagée."],
        ["Régie", "Des techniciens ENOVA intégrés à vos équipes, dans vos locaux, sous votre pilotage."],
        ["À distance & sur site", "Prise en main à distance pour aller vite, intervention sur site quand c'est nécessaire."],
      ],
      results: ["Des utilisateurs accompagnés", "Un service mesuré et piloté", "Une équipe IT recentrée sur ses projets"],
    },
    brands: [],
    faq: [
      ["Pouvez-vous reprendre un support existant ?", "Oui. Nous partons de votre organisation, de vos outils et de vos process, puis nous définissons ensemble le périmètre repris et les modalités de transition."],
      ["Comment sont définis les niveaux de service ?", "Les SLA sont construits avec vous selon vos enjeux : horaires, priorités, délais de prise en charge et de résolution. Ils font l'objet d'un reporting régulier."],
      ["Travaillez-vous dans notre outil de ticketing ?", "Nous nous adaptons : nous pouvons travailler dans votre outil existant ou vous accompagner dans le choix et la mise en place d'un outil."],
    ],
  },
  {
    slug: "reseaux",
    name: "Réseaux & infrastructures",
    logo: "enova-wordmark",
    color: "#45ADE0",
    icon: "network",
    tagline: "Des infrastructures réseau fiables et sécurisées, du site unique au multi-sites.",
    short: "LAN, WAN, Wi-Fi professionnel, interconnexion de sites, segmentation, supervision.",
    image: "ceiling",
    pains: [
      "Le Wi-Fi ne suit pas la densité d'utilisateurs ou la surface de vos locaux.",
      "Vos sites ne sont pas reliés entre eux de façon fiable et sécurisée.",
      "Invités, production, administration : tout circule sur le même réseau.",
      "Une coupure n'est détectée que lorsque les utilisateurs la signalent.",
    ],
    offers: [
      ["Conception & déploiement", "Architecture LAN, câblage, baies et équipements actifs, dimensionnés pour votre activité."],
      ["Wi-Fi professionnel", "Couverture étudiée, bornes UniFi, réseau invités et portail captif."],
      ["Interconnexion de sites", "Liaisons WAN et connexions sécurisées entre vos implantations."],
      ["Segmentation & sécurité", "Séparation des flux (VLAN), filtrage et règles d'accès adaptées à chaque usage."],
      ["Supervision & exploitation", "Surveillance des équipements, mises à jour et interventions pour garantir la disponibilité du réseau."],
    ],
    brands: ["Ubiquiti UniFi"],
    faq: [
      ["Intervenez-vous sur des environnements multi-sites ?", "Oui. Nous concevons et exploitons des réseaux sur un site unique comme sur plusieurs implantations reliées entre elles."],
      ["Pouvez-vous reprendre un réseau existant ?", "Oui : audit de l'existant, documentation, puis plan d'amélioration priorisé."],
    ],
  },
  {
    slug: "cloud",
    name: "Cloud",
    logo: "enova-wordmark",
    color: "#45ADE0",
    icon: "cloud",
    tagline: "Vos services et vos données disponibles, sauvegardés et sécurisés.",
    short: "Microsoft 365, hébergement de services métiers, sauvegarde, échange de données.",
    image: "cloudAdmin",
    pains: [
      "Messagerie et fichiers dispersés entre plusieurs outils et appareils.",
      "Des applications métiers hébergées sur un serveur vieillissant.",
      "Des sauvegardes jamais testées et aucun plan de reprise.",
      "Des licences Microsoft qui s'accumulent sans visibilité.",
    ],
    offers: [
      ["Microsoft 365", "Messagerie, Teams, OneDrive, SharePoint : migration, sécurisation et gestion des licences."],
      ["Hébergement & migration", "Migration ou hébergement de vos services métiers, avec une attention portée à la disponibilité."],
      ["Sauvegarde & reprise", "Sauvegardes externalisées, tests de restauration et plan de reprise d'activité."],
      ["Sécurité des accès", "Double authentification, gestion des droits et des comptes."],
      ["Échange de données sécurisé", "Partage de fichiers avec vos clients et partenaires, en gardant la maîtrise des accès."],
    ],
    brands: ["Microsoft 365"],
    faq: [
      ["Pouvez-vous migrer notre messagerie existante ?", "Oui. La migration est planifiée avec vous pour limiter l'impact sur vos utilisateurs."],
      ["Où sont hébergées nos données ?", "Le choix de l'hébergement est fait avec vous, selon vos contraintes de sécurité, de disponibilité et de réglementation."],
    ],
  },
  {
    slug: "telephonie",
    name: "Téléphonie & communications",
    color: "#E3B321",
    icon: "phone",
    tagline: "Une téléphonie d'entreprise disponible, pilotée et mesurée, du standard au centre d'appels.",
    short: "VoIP, standards IPBX, centres d'appels, postes fixes et DECT.",
    image: "phone",
    pains: [
      "Les clients tombent sur une messagerie pleine ou sur une sonnerie dans le vide.",
      "Impossible de transférer un appel proprement d'un bureau à l'autre.",
      "L'ancien standard n'est plus maintenu et les pièces sont introuvables.",
      "Vos équipes en déplacement ne sont pas joignables sur le numéro de l'entreprise.",
    ],
    offers: [
      ["Standard IPBX", "Serveur vocal, files d'attente, horaires d'ouverture, renvois : votre accueil téléphonique, configuré pour vous."],
      ["Postes fixes & DECT", "Postes IP Fanvil et Grandstream, combinés sans fil pour l'atelier ou l'entrepôt."],
      ["Centre d'appels", "Files d'attente, connexion des agents, enregistrement et statistiques pour les équipes qui gèrent un volume d'appels important."],
      ["Mobilité", "Application softphone : votre ligne pro sur votre smartphone ou votre ordinateur."],
    ],
    brands: ["Xorcom", "Fanvil", "Grandstream"],
    faq: [
      ["Peut-on garder nos numéros actuels ?", "Oui. Nous gérons la portabilité de vos numéros auprès de l'opérateur, sans interruption de service."],
      ["Faut-il recâbler les locaux ?", "Rarement. Les postes IP utilisent le réseau informatique existant ; nous faisons un audit avant toute installation."],
      ["Intervenez-vous sur plusieurs sites ?", "Oui. Nous relions les sites entre eux par des connexions sécurisées, avec des appels internes gratuits entre implantations."],
    ],
  },
  {
    slug: "conseil-audit",
    name: "Conseil & Audit",
    color: "#A6C46B",
    icon: "bubble",
    tagline: "Le support autrement : plus pertinent, plus efficace, moins énergivore.",
    short: "Mise en service, revue de process, pilotage de Service Desk N1 / N2 / N3, audit.",
    image: "meeting",
    pains: [
      "Vos équipes support travaillent en permanence dans l'urgence et s'épuisent.",
      "Les demandes arrivent par tous les canaux, sans priorisation ni suivi clair.",
      "Le partage des rôles entre niveau 1 et niveau 2 est flou : les tickets rebondissent.",
      "Un nouveau système doit être mis en service sans perturber l'activité.",
    ],
    offers: [
      ["Mise en service", "Préparation, déploiement et bascule de vos nouveaux systèmes, avec un plan de démarrage maîtrisé."],
      ["Revue de process", "Analyse de vos processus support et IT pour supprimer les frictions, les doublons et les pertes de temps."],
      ["Pilotage de Service Desk", "Organisation, indicateurs, priorisation, comités de suivi : un Service Desk piloté plutôt que subi."],
      ["Niveau 1 & Niveau 2", "Structuration ou prise en charge de vos niveaux 1 et 2 : qualification, résolution et escalade au bon niveau."],
      ["Audit & schéma directeur", "État des lieux du parc, de la sécurité et de l'organisation, puis un plan d'action priorisé et chiffré."],
    ],
    inHouse: {
      eyebrow: "Notre ADN",
      title: "ENOVA est née dans le secteur minier.",
      lead: "Le besoin était clair : travailler autrement, ne plus intervenir uniquement dans l'urgence, mais exercer le métier du support de façon plus pertinente, plus efficace et moins énergivore pour les équipes. C'est cette approche que nous apportons à chacun de nos clients.",
      items: [
        ["Comprendre le métier", "Nous partons de vos opérations et de vos contraintes terrain, pas des outils."],
        ["Anticiper plutôt que subir", "Des process et des indicateurs qui permettent d'agir avant l'incident."],
        ["Chacun à sa place", "Des rôles N1 / N2 / N3 clairs pour que chaque demande soit traitée au bon niveau, du premier coup."],
        ["Préserver les équipes", "Moins d'urgence, moins de dispersion : des équipes plus sereines et plus efficaces."],
      ],
      results: ["Plus pertinent", "Plus efficace", "Moins énergivore pour les équipes"],
    },
    brands: ["Microsoft", "Ubiquiti", "Lenovo"],
    faq: [
      ["Pouvez-vous piloter notre Service Desk ?", "Oui. Nous pouvons structurer et piloter votre Service Desk existant, ou prendre en charge tout ou partie de vos niveaux 1, 2 et 3."],
      ["Comment se déroule un audit ?", "Le périmètre et la durée sont définis avec vous. L'audit se conclut par un rapport et une restitution, avec un plan d'action priorisé."],
      ["L'audit m'engage-t-il à signer un contrat ?", "Non. Le rapport vous appartient ; vous pouvez le mettre en œuvre avec nous ou avec un autre prestataire."],
    ],
  },
  {
    slug: "vente-import",
    name: "Vente & Import",
    color: "#EE8445",
    icon: "box",
    tagline: "Vous connaissez votre besoin, nous vous proposons les choix qui y répondent.",
    short: "Conseil d'achat, import, livraison, préparation, maintenance et renouvellement.",
    image: "office",
    pains: [
      "Vous savez ce qu'il vous faut, mais pas quel modèle choisir parmi des dizaines de références.",
      "Le matériel disponible localement ne correspond pas toujours à votre besoin.",
      "Une fois livré, le matériel reste à installer, à configurer et à suivre dans le temps.",
    ],
    offers: [
      ["Des choix adaptés", "Vous exprimez votre besoin, nous vous proposons plusieurs options comparées, au juste prix."],
      ["Postes, portables & serveurs", "Lenovo, HP : du matériel professionnel conçu pour durer."],
      ["Écrans, visio & accessoires", "Logitech pour les salles de réunion, casques et webcams pour le travail hybride."],
      ["Import sur mesure", "Nous sourçons et importons le matériel spécifique dont vous avez besoin."],
    ],
    inHouse: {
      eyebrow: "À la carte",
      title: "Pour la suite, c'est comme vous voulez.",
      lead: "Vous choisissez jusqu'où nous vous accompagnons, du simple achat à la gestion complète de votre matériel. C'est vous qui décidez !",
      items: [
        ["On livre", "Le matériel arrive chez vous, dans vos locaux."],
        ["On prépare", "Configuration, logiciels, comptes et données : tout est prêt avant la mise en service."],
        ["On démarre avec vous", "Installation sur site et prise en main avec vos équipes."],
        ["On assure la maintenance", "Suivi, garanties et dépannage tout au long de la vie du matériel."],
        ["On renouvelle", "Nous anticipons le remplacement de votre parc au bon moment."],
      ],
      results: ["Vous connaissez votre besoin", "Nous proposons les choix", "Vous décidez de la suite"],
    },
    brands: ["Lenovo", "HP", "Logitech", "Ubiquiti"],
    faq: [
      ["Puis-je seulement acheter le matériel ?", "Oui. Livraison, préparation, démarrage, maintenance et renouvellement sont proposés à la carte : vous choisissez ce dont vous avez besoin."],
    ],
  },
  {
    slug: "ia-automatisation",
    name: "IA & Automatisation",
    logo: "enova-wordmark-ia",
    color: "#4AAAB0",
    icon: "screen",
    tagline: "L'IA et l'automatisation au service de votre métier : moins de temps sur les outils, plus sur l'essentiel.",
    short: "Automatisation des processus, assistants IA, outils et applications sur mesure.",
    image: "team",
    pains: [
      "Vos équipes passent des heures sur des tâches répétitives : ressaisies, relances, comptes rendus.",
      "Vos outils ne communiquent pas entre eux et les informations circulent par copier-coller.",
      "Vous entendez parler d'IA partout, sans savoir par où commencer ni quoi en attendre.",
      "Vous voulez utiliser l'IA sans exposer les données confidentielles de vos clients.",
    ],
    offers: [
      ["Automatisation des processus", "Devis, relances, saisies, rapports, validations : nous automatisons les tâches répétitives pour libérer du temps à vos équipes."],
      ["Assistants IA au quotidien", "Claude et ChatGPT intégrés à vos usages : rédaction, synthèse de documents, recherche d'informations, réponses clients."],
      ["Outils sur mesure", "Calculateurs, tableaux de bord, formulaires, générateurs de documents : de petits outils créés avec l'IA, mis en place rapidement."],
      ["Applications métier", "Des applications web développées rapidement, adaptées à votre façon de travailler et connectées à vos outils existants."],
      ["Accompagnement & formation", "Choix des bons outils, bonnes pratiques, règles de confidentialité et formation de vos équipes."],
    ],
    brands: ["Claude", "ChatGPT", "Microsoft 365"],
    inHouse: {
      title: "Nous l'appliquons d'abord chez nous.",
      lead: "Avant de vous le proposer, nous avons automatisé notre propre support avec l'IA.",
      items: [
        ["Demandes clients par e-mail", "Traitement automatisé des e-mails entrants : chaque demande est lue, comprise et orientée sans attendre."],
        ["Classement & identification", "Les demandes sont classées, rangées et rattachées au bon client et au bon équipement."],
        ["Détection de panne", "Les signaux faibles sont repérés plus tôt, pour intervenir avant que la panne ne bloque votre activité."],
        ["Aide au diagnostic", "Le technicien dispose immédiatement de l'historique et des pistes de résolution les plus probables."],
        ["Suivi des projets & tâches", "Chaque projet et chaque tâche sont suivis et relancés automatiquement : rien ne se perd."],
      ],
      results: ["Plus de réactivité", "Des réponses plus justes", "Un dépannage plus rapide et moins coûteux"],
    },
    faq: [
      ["Par où commencer ?", "Par un échange sur vos processus : nous repérons les tâches qui vous font perdre le plus de temps, puis nous proposons une première automatisation simple, rapide à mettre en place et facile à mesurer."],
      ["Nos données sont-elles protégées ?", "Oui. Nous choisissons des offres professionnelles qui n'utilisent pas vos données pour entraîner les modèles, et nous définissons avec vous ce qui peut ou non être confié à une IA."],
      ["Faut-il des compétences techniques ?", "Non. Nous concevons et mettons en place les outils ; vos équipes les utilisent simplement, après une courte prise en main."],
    ],
  },
];

export const themeBySlug = (slug) => THEMES.find((t) => t.slug === slug);

export const STEPS = [
  ["Écoute", "Un premier échange pour comprendre votre activité, vos enjeux et le périmètre à confier."],
  ["Diagnostic", "Visite sur site si nécessaire et analyse de l'existant."],
  ["Proposition", "Un périmètre, des engagements de service et un devis clairs."],
  ["Mise en place", "Installation planifiée pour ne pas bloquer votre activité."],
  ["Exploitation & suivi", "Un interlocuteur unique, un support ouvert de 7h à 17h et un reporting régulier."],
];

export const SOLUTIONS = [
  {
    slug: "ouvrir-mes-locaux",
    title: "J'ouvre mes locaux",
    lead: "Nouvelle agence, déménagement, extension : tout doit fonctionner le jour de l'ouverture.",
    themes: ["reseaux", "telephonie", "vente-import"],
    points: [
      "Réseau, baie et Wi-Fi professionnel installés avant votre arrivée",
      "Standard téléphonique et numéros transférés sans coupure",
      "Postes livrés, configurés et connectés à Microsoft 365",
      "Un planning unique, un seul interlocuteur",
    ],
  },
  {
    slug: "securiser-mon-informatique",
    title: "Je sécurise mon informatique",
    lead: "Rançongiciel, perte de données, accès non maîtrisés : réduisez les risques pas à pas.",
    themes: ["conseil-audit", "infogerance", "cloud"],
    points: [
      "Audit de sécurité et liste de priorités chiffrée",
      "Sauvegardes externalisées et testées",
      "Double authentification Microsoft 365",
      "Supervision et mises à jour automatiques",
    ],
  },
  {
    slug: "moderniser-ma-telephonie",
    title: "Je modernise ma téléphonie",
    lead: "Fini les appels perdus : un accueil professionnel, même quand vous êtes en déplacement.",
    themes: ["telephonie", "infogerance"],
    points: [
      "Standard IPBX avec serveur vocal et files d'attente",
      "Postes IP Fanvil / Grandstream et DECT",
      "Votre ligne pro sur smartphone",
      "Portabilité des numéros existants",
    ],
  },
  {
    slug: "renouveler-mon-parc",
    title: "Je change mon parc ordinateurs",
    lead: "Des postes vieillissants qui ralentissent vos équipes : un renouvellement planifié, sans interrompre l'activité.",
    themes: ["vente-import", "service-desk", "infogerance"],
    points: [
      "Inventaire du parc et choix des modèles adaptés à chaque usage (Lenovo, HP)",
      "Postes préparés et configurés avant livraison",
      "Migration des données et déploiement sur site, poste par poste",
      "Accompagnement des utilisateurs à la prise en main",
    ],
  },
  {
    slug: "relier-mes-sites",
    title: "Je relie mes sites sur plusieurs kilomètres",
    lead: "Un entrepôt, un atelier, un second bâtiment éloigné : un pont Wi-Fi les relie en haut débit, sans tranchée.",
    themes: ["reseaux", "infogerance"],
    points: [
      "Étude de faisabilité et vérification de la visibilité entre les sites",
      "Pont Wi-Fi point à point haut débit sur plusieurs kilomètres",
      "Liaison chiffrée, intégrée à votre réseau d'entreprise",
      "Supervision de la liaison au quotidien",
    ],
  },
  {
    slug: "wifi-public-conforme",
    title: "Je contrôle mon Wi-Fi public, en règle",
    lead: "Hôtel, commerce, salle d'attente : offrir un accès Wi-Fi à vos visiteurs vous impose des obligations légales.",
    themes: ["reseaux", "conseil-audit"],
    points: [
      "Portail captif à vos couleurs, avec conditions d'utilisation à accepter",
      "Conservation des données techniques de connexion pendant un an, conformément aux obligations légales en vigueur",
      "Aucune conservation du contenu des échanges ni des sites consultés",
      "Réseau invité séparé de votre réseau interne",
      "Information des utilisateurs sur le traitement de leurs données",
    ],
  },
];

export const CASES = [
  {
    id: "minier-service-desk",
    theme: "service-desk",
    client: "Acteur du secteur minier · Nouvelle-Calédonie",
    title: "Pilotage du Service Desk et revue des process support",
    context: "Un support informatique sous pression permanente, sur des sites en exploitation : des demandes traitées dans l'urgence, des rôles N1 / N2 mal définis et des équipes épuisées.",
    solution: "Revue complète des process support, réorganisation des niveaux 1 et 2, mise en place d'indicateurs et pilotage du Service Desk au quotidien.",
    result: "Un support qui anticipe au lieu de subir : des demandes traitées au bon niveau, une meilleure réactivité sur le terrain et des équipes moins sollicitées dans l'urgence.",
    image: "mine",
    metrics: [["> 95 %", "taux de décroché"], ["> 3 000", "utilisateurs"], ["> 1 500", "postes de travail"]],
  },
  {
    id: "enova-support-ia",
    theme: "ia-automatisation",
    client: "ENOVA · En interne",
    title: "Notre propre support, automatisé par l'IA",
    context: "Des demandes clients par e-mail à trier, classer et orienter à la main.",
    solution: "Traitement automatisé des e-mails, classement, identification, aide au diagnostic et suivi des tâches.",
    result: "Plus de réactivité, de meilleures réponses, un dépannage plus rapide et moins coûteux.",
    image: "iaSupport",
  },

  {
    id: "association-numero-vert",
    theme: "telephonie",
    client: "Association d'aide aux personnes en détresse",
    title: "Un numéro vert qui répond aussi la nuit, depuis la maison",
    context: "Des appels à recevoir de nuit, par des écoutants qui ne peuvent pas être présents dans les locaux.",
    solution: "Numéro vert et application sécurisée : les écoutants se connectent au serveur depuis chez eux, avec une simple connexion Internet.",
    result: "Suivi et maîtrise complète des appels, télétravail et confort d'usage pour les équipes.",
    image: "helpline",
  },
  {
    id: "retail-4-magasins",
    theme: "telephonie",
    client: "Enseigne de distribution · 4 magasins",
    title: "4 magasins reliés de Nouméa à Pouembout",
    context: "Quatre magasins répartis sur le territoire, des appels entre sites facturés et des lignes coûteuses.",
    solution: "4 serveurs reliés par des connexions sécurisées, plus de 200 combinés, analyse des coûts et optimisation des lignes OPT.",
    result: "Appels gratuits entre tous les sites et facture télécom optimisée.",
    image: "phone",
    metrics: [["4", "serveurs interconnectés"], ["> 200", "combinés téléphoniques"], ["Gratuit", "entre tous les sites"]],
  },
  {
    id: "salle-de-gym",
    theme: "telephonie",
    client: "Salle de sport · Nouméa · 5 sites",
    title: "Un seul serveur, et chaque appel arrive dans la bonne salle",
    context: "Cinq salles et des clients qui appellent sans savoir quel numéro composer.",
    solution: "Un serveur unique pour les 5 sites, avec une redirection automatique des appels vers la salle choisie par le client.",
    result: "Des appels toujours orientés vers la bonne salle, sans standardiste.",
    image: "gym",
    metrics: [["5", "sites"], ["1", "serveur"]],
  },
  {
    id: "hotel-du-centre",
    theme: "telephonie",
    client: "Hôtel du Centre · Nouméa",
    title: "Migration complète de la téléphonie d'un hôtel complet, sans aucune coupure",
    context: "Un PABX Aastra vieillissant et des licences trop coûteuses pour ajouter des postes, dans un hôtel occupé à 100 % pendant le chantier.",
    solution: "IPBX Xorcom XR2000 sans licence, postes configurés automatiquement (provisioning), couplage direct au logiciel hôtelier Amadeus (FIAS), formation des équipes.",
    result: "Aucune coupure de service, un serveur en moins à maintenir et des postes ajoutés sans surcoût de licences.",
    image: "hotel",
    metrics: [["~90", "postes migrés"], ["½ journée", "pour configurer les postes"]],
    source: ["Lire l'article de notre partenaire IP Connect", "https://www.ipconnect.fr/migration-reussie-pour-notre-partenaire-enova-a-lhotel-du-centre/"],
  },
  {
    id: "banque-service-desk",
    theme: "telephonie",
    client: "Banque · Service Desk",
    title: "Une file d'attente pilotée pour le Service Desk",
    context: "Un Service Desk bancaire qui devait mieux répartir les appels et mesurer son activité.",
    solution: "Gestion de file d'attente, connexion et déconnexion (log / délog) des agents, statistiques complètes.",
    result: "Une charge répartie entre les agents et une activité mesurée en temps réel.",
    image: "callCenter",
  },




];

export const KPIS = [
  { value: "17 ans", label: "d'expérience, depuis juin 2009" },
  { value: "+4 000", label: "utilisateurs gérés" },
  { value: "+10 000", label: "postes et équipements gérés" },
  { value: "+100", label: "sites accompagnés" },
  { value: "10", label: "techniciens et techniciennes, du niveau 1 au niveau 3" },
  { value: "N1 / N2 / N3", label: "support utilisateurs, à distance et sur site" },
  { value: "Multi-sites", label: "environnements exploités sur plusieurs implantations" },
];

export const USE_CASES = [
  { id: "uc-service-desk", theme: "service-desk", title: "Service Desk & Support utilisateurs", text: "Mise en œuvre d'un centre de support avec gestion des tickets, SLA, téléphonie, reporting et gestion des escalades.", tags: ["Tickets", "SLA", "Escalades", "Reporting"], image: "callCenter" },
  { id: "uc-multi-sites", theme: "vente-import", title: "Déploiement multi-sites", text: "Migration et renouvellement de postes de travail sur plusieurs implantations, avec coordination logistique et support utilisateurs.", tags: ["Postes de travail", "Logistique", "Support"], image: "office" },
  { id: "uc-reseau", theme: "reseaux", title: "Infrastructure réseau", text: "Conception et modernisation d'une infrastructure réseau d'entreprise avec Wi-Fi professionnel, segmentation et supervision.", tags: ["Wi-Fi pro", "Segmentation", "Supervision"], image: "ceiling" },
  { id: "uc-telephonie", theme: "telephonie", title: "Téléphonie & centre d'appels", text: "Déploiement d'une solution de téléphonie d'entreprise et de centre d'appels avec files d'attente, enregistrement et statistiques.", tags: ["IPBX", "Files d'attente", "Statistiques"], image: "phoneRoom" },
  { id: "uc-cloud", theme: "cloud", title: "Cloud & Infrastructure", text: "Migration ou hébergement de services métiers avec gestion des sauvegardes, de la disponibilité et de la sécurité.", tags: ["Sauvegardes", "Disponibilité", "Sécurité"], image: "rack" },
];

export const COMMITMENT = [
  ["Nous l'exploitons", "Maintenance, mises à jour, sauvegardes : votre SI fonctionne au quotidien."],
  ["Nous le supervisons", "Les incidents sont détectés et traités avant de bloquer votre activité."],
  ["Nous accompagnons vos utilisateurs", "Hotline, support N1 / N2 / N3, à distance et sur site."],
  ["Nous rendons compte", "Indicateurs, reporting et points de suivi : vous savez ce qui est fait."],
];

export const BRANDS = [
  ["Lenovo", "lenovo.svg", "h-5"], ["HP", "hp.svg", "h-9"], ["Logitech", "logitech.svg"], ["Ubiquiti", "ubiquiti.png", "h-9"],
  ["Microsoft", "microsoft.svg"], ["Xorcom", "xorcom.png"], ["Fanvil", "fanvil.png"], ["Grandstream", "grandstream.png"],
];

export const SUPPORT_FAQ = [
  ["Mon poste ne démarre plus", "Vérifiez l'alimentation et l'écran, puis maintenez le bouton marche 10 secondes. Si rien ne change, ouvrez une demande urgente."],
  ["Plus d'Internet au bureau", "Redémarrez la box opérateur puis le switch. Si un seul poste est concerné, débranchez et rebranchez son câble réseau."],
  ["Je n'arrive plus à me connecter à Outlook", "Vérifiez votre mot de passe sur office.com. Si votre compte est bloqué, appelez la hotline : nous le débloquons à distance."],
  ["Mon téléphone de bureau affiche « non enregistré »", "Débranchez le poste 10 secondes et rebranchez-le. Si le message persiste, signalez-le avec le numéro du poste."],
];

export const onColor = (c) => (c === "#E3B321" ? "#333333" : "#ffffff");
